/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { modalTypes } from "constants/types";
import { hideModal } from "slices/app/actions/modals";
import { selectDocuments } from "slices/discovery/selectors";
import { applyFilter } from "slices/discovery/actions/filters";
import { getImage } from "utils";
import { FILTER_TYPES } from "constants/discovery";
import { setFilterDocID } from "slices/discovery/discoverySlice";
import {fetchUniqueItemsCount} from "slices/discovery/actions/theme";

const SelectDocumentModal = () => {
  const dispatch = useDispatch();

  const documents = useSelector(selectDocuments);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);

  const closeModal = () => {
    dispatch(hideModal(modalTypes.SELECT_DOCUMENT));
  };

  const handleDocumentClick = (id) => {
    setSelectedDocumentId(id);
  };

  const handleConfirmClick = () => {
    closeModal();
    dispatch(setFilterDocID(selectedDocumentId));
    dispatch(applyFilter(FILTER_TYPES.GAPS_RELATIVE_TO_A_REFERENCE_DOC));
    dispatch(fetchUniqueItemsCount(FILTER_TYPES.GAPS_RELATIVE_TO_A_REFERENCE_DOC, selectedDocumentId));
  };

  const handleCancelClick = () => {
    closeModal();
  };

  return (
    <Modal
      show
      centered
      backdrop="static"
      className="fade-in discovery_select_document_modal"
      onDismiss={closeModal}
    >
      <Modal.Header closeButton>
        <b>Gaps relative to single document</b>
      </Modal.Header>
      <Modal.Body>
        <div className="discovery_select_document_modal__note">
          Choose the document:
        </div>
        <ul className="discovery_select_document_modal__document_list">
          {documents.map(({ Id, Name }) => {
            return (
              <li
                key={Id}
                className={clsx(
                  "discovery_select_document_modal__document_list__document",
                  { selected: Id === selectedDocumentId }
                )}
                onClick={() => handleDocumentClick(Id)}
              >
                <img src={getImage(Name)} alt="document-icon" />
                {Name}
              </li>
            );
          })}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button
          content="Confirm"
          variant={buttonVariants.primary}
          disabled={selectedDocumentId === null}
          onClick={handleConfirmClick}
        />
        <Button
          content="Cancel"
          variant={buttonVariants.secondary}
          onClick={handleCancelClick}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default SelectDocumentModal;
